import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import DefaultLayout from '../Layouts/DefaultLayout';

import ContentList from '../Components/ContentList';
import TypeTitle from '../Components/TypeTitle';

function App() {
    const [type, setType] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { tipo } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchType = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/tipos/${tipo}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Categoria não encontrada!' },
                            },
                        });
                        redirected = true;
                        return;
                    }
                    throw new Error('Erro ao buscar a categoria.');
                }

                const data = await response.json();
                setType(data.tipo);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchType();
    }, [tipo]);

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <TypeTitle typeName={type.nome} loading={loading} />
                        {loading && (
                            <>
                                <ContentList loading={loading} />
                                <ContentList loading={loading} />
                            </>
                        )}
                        {type.categorias &&
                            type.categorias.map((item, index) => {
                                const anchor = window.location.hash.replace('#', '');
                                const isActive = anchor ? anchor === item.slug : index === 0;
                                return (
                                    <ContentList
                                        key={index}
                                        content={item.produtos}
                                        url={`/painel/produtos/${type.slug}/`}
                                        title={item.nome}
                                        anchor={item.slug}
                                        loading={loading}
                                        active={isActive}
                                    />
                                );
                            })}
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
